<!-- 受診者抽出 一覧画面 -->
<style src="@/assets/css/admin_parts.css" type="text/css" media="all" scoped></style>
<style scoped>

</style>
<template>
	<!-- ▽  -->
	<div class="contents" id="wiga1">
		<section id="mainContent">
			<h2>受診者抽出</h2>
			<!-- ▽ 抽出条件入力 -->
			<section class="inputArea">
				<!-- 検索条件項目 -->
				<table class="inputTbl">
					<tbody>
						<tr>
							<th>クライアント名</th>
								<td>
									<select v-model="inputForm.jgcd">
										<option value="">選択</option>
										<option v-for="item in inputForm.jgyoList" v-bind:value="item.jgcd" v-bind:key="item.jgcd">
											{{item.jgnm}}
										</option>
									</select>
								</td>
							<th>健康保険組合名</th>
								<td colspan="3"><input type="text" v-model="inputForm.jgnm"></td>
						</tr>
						<tr>
							<th>企業名</th>
								<td colspan="5"><input type="text" v-model="inputForm.cmnm"></td>
						</tr>
						<tr>
							<th>保険証記号</th>
								<td><input type="text" v-model="inputForm.hkkg" maxlength="15"></td>
							<th>患者番号</th>
								<td colspan="3"><input type="text" v-model="inputForm.trno" maxlength="10"></td>
						</tr>
						<tr>
							<th>予約枠</th>
								<td>
									<select v-model="inputForm.waku">
										<option value="">未選択</option>
										<option v-for="item in inputForm.wakuList" v-bind:value="item.waku" v-bind:key="item.waku">
											{{item.wknm}}
										</option>
									</select>
								</td>
							<th>予約番号</th>
								<td><input type="text" v-model="inputForm.ukno" maxlength="9"></td>
							<th>予約年度</th>
								<td class="dateY"><input type="text" v-model="inputForm.nend" maxlength="4">年度</td>
						</tr>
						<tr>
							<th>オプション分類</th>
								<td>
									<select v-model="inputForm.opbr">
										<option value="">未選択</option>
										<option v-for="item in inputForm.opbrList" v-bind:value="item.opbr" v-bind:key="item.opbr">
											{{item.nbnm}}
										</option>
									</select>
								</td>
							<th>オプション項目</th>
								<td colspan="3">
									<select v-model="inputForm.opcd">
										<option value="">未選択</option>
										<option v-for="item in filteredOpbrList" v-bind:value="item.opcd" v-bind:key="item.opcd">
											{{item.nbnm}}
										</option>
									</select>
								</td>
						</tr>
						<tr>
							<th>受診日</th>
								<td colspan="5" class="dayForm">
										<ul>
											<li>
												<select v-model="inputForm.ykdyStartYear">
													<option value=0>未選択</option>
													<option v-for="item in inputForm.yearList" v-bind:key="item">
														{{item}}
													</option>
												</select>
											</li>
											<li>
												<select v-model="inputForm.ykdyStartMonth">
													<option value=0>未選択</option>
													<option v-for="item in inputForm.monthList" v-bind:key="item">
														{{item}}
													</option>
												</select>
											</li>
											<li>
												<select v-model="inputForm.ykdyStartDate">
													<option value=0>未選択</option>
													<option v-for="item in computedListYkdyStartDate" v-bind:key="item">
														{{item}}
													</option>
												</select>
											</li>
										</ul>
										<ul>
											<li>
												<select v-model="inputForm.ykdyEndYear">
													<option value=0>未選択</option>
													<option v-for="item in inputForm.yearList" v-bind:key="item">
														{{item}}
													</option>
												</select>
											</li>
											<li>
												<select v-model="inputForm.ykdyEndMonth">
													<option value=0>未選択</option>
													<option v-for="item in inputForm.monthList" v-bind:key="item">
														{{item}}
													</option>
												</select>
											</li>
											<li>
												<select v-model="inputForm.ykdyEndDate">
													<option value=0>未選択</option>
													<option v-for="item in computedListYkdyEndDate" v-bind:key="item">
														{{item}}
													</option>
												</select>
											</li>
										</ul>
								</td>
						</tr>
						<tr>
							<th>予約登録日</th>
								<td colspan="5" class="dayForm">
										<ul>
											<li>
												<select v-model="inputForm.crdtStartYear">
													<option value=0>未選択</option>
													<option v-for="item in inputForm.yearList" v-bind:key="item">
														{{item}}
													</option>
												</select>
											</li>
											<li>
												<select v-model="inputForm.crdtStartMonth">
													<option value=0>未選択</option>
													<option v-for="item in inputForm.monthList" v-bind:key="item">
														{{item}}
													</option>
												</select>
											</li>
											<li>
												<select v-model="inputForm.crdtStartDate">
													<option value=0>未選択</option>
													<option v-for="item in computedListCrdtStartDate" v-bind:key="item">
														{{item}}
													</option>
												</select>
											</li>
										</ul>
										<ul>
											<li>
												<select v-model="inputForm.crdtEndYear">
													<option value=0>未選択</option>
													<option v-for="item in inputForm.yearList" v-bind:key="item">
														{{item}}
													</option>
												</select>
											</li>
											<li>
												<select v-model="inputForm.crdtEndMonth">
													<option value=0>未選択</option>
													<option v-for="item in inputForm.monthList" v-bind:key="item">
														{{item}}
													</option>
												</select>
											</li>
											<li>
												<select v-model="inputForm.crdtEndDate">
													<option value=0>未選択</option>
													<option v-for="item in computedListCrdtEndDate" v-bind:key="item">
														{{item}}
													</option>
												</select>
											</li>
										</ul>
								</td>
						</tr>
						<tr>
							<th>予約更新日</th>
								<td colspan="5" class="dayForm">
										<ul>
											<li>
												<select v-model="inputForm.updtStartYear">
													<option value=0>未選択</option>
													<option v-for="item in inputForm.yearList" v-bind:key="item">
														{{item}}
													</option>
												</select>
											</li>
											<li>
												<select v-model="inputForm.updtStartMonth">
													<option value=0>未選択</option>
													<option v-for="item in inputForm.monthList" v-bind:key="item">
														{{item}}
													</option>
												</select>
											</li>
											<li>
												<select v-model="inputForm.updtStartDate">
													<option value=0>未選択</option>
													<option v-for="item in computedListUpdtStartDate" v-bind:key="item">
														{{item}}
													</option>
												</select>
											</li>
										</ul>
										<ul>
											<li>
												<select v-model="inputForm.updtEndYear">
													<option value=0>未選択</option>
													<option v-for="item in inputForm.yearList" v-bind:key="item">
														{{item}}
													</option>
												</select>
											</li>
											<li>
												<select v-model="inputForm.updtEndMonth">
													<option value=0>未選択</option>
													<option v-for="item in inputForm.monthList" v-bind:key="item">
														{{item}}
													</option>
												</select>
											</li>
											<li>
												<select v-model="inputForm.updtEndDate">
													<option value=0>未選択</option>
													<option v-for="item in computedListUpdtEndDate" v-bind:key="item">
														{{item}}
													</option>
												</select>
											</li>
										</ul>
								</td>
						</tr>
					</tbody>
				</table>
				<!-- 検索ボタン -->
				<div class="btnLst">
					<button class="onSearch" v-on:click="onSearch">検索</button>
				</div>
        <!-- 絞り込み検索条件項目 -->
				<table class="inputTbl">
					<caption class="listUp"><b>絞り込み検索</b></caption>
					<tbody>
						<tr>
							<th>ステータス</th>
								<td>
									<ul class="radioLst">
										<li>
											<label for="ykst21" class="checkbox"><input type="checkbox" name="ykst" id="ykst21" value="21" v-model="inputForm.ykst" v-on:change="changeYkst"><span>予約（新規　確認未）</span></label>
											<label for="ykst22" class="checkbox"><input type="checkbox" name="ykst" id="ykst22" value="22" v-model="inputForm.ykst" v-on:change="changeYkst"><span>予約（変更　確認未）</span></label>
											<label for="ykst23" class="checkbox"><input type="checkbox" name="ykst" id="ykst23" value="23" v-model="inputForm.ykst" v-on:change="changeYkst"><span>予約（確認済）</span></label>
										</li>
										<li>
											<label for="ykst91" class="checkbox"><input type="checkbox" name="ykst" id="ykst91" value="91" v-model="inputForm.ykst" v-on:change="changeYkst"><span>キャンセル（確認未）</span></label>
											<label for="ykst92" class="checkbox"><input type="checkbox" name="ykst" id="ykst92" value="92" v-model="inputForm.ykst" v-on:change="changeYkst"><span>キャンセル（確認済）</span></label>
											<label for="ykst99" class="checkbox"><input type="checkbox" name="ykst" id="ykst99" value="99" v-model="inputForm.ykst" v-on:change="changeYkst"><span>キャンセル（削除済）</span></label>
										</li>
									</ul>
								</td>
							<th>ダウンロード状況</th>
								<td>
									<ul class="radioLst">
										<li>
											<label for="csst01" class="checkbox"><input type="checkbox" name="csst" id="csst01" value="01" v-model="inputForm.csst" v-on:change="changeCsst"><span>未（新規）</span></label>
											<label for="csst02" class="checkbox"><input type="checkbox" name="csst" id="csst02" value="02" v-model="inputForm.csst" v-on:change="changeCsst"><span>未（変更・キャンセル）</span></label>
										</li>
										<li>
											<label for="csst03" class="checkbox"><input type="checkbox" name="csst" id="csst03" value="03" v-model="inputForm.csst" v-on:change="changeCsst"><span>済</span></label>
										</li>
									</ul>
								</td>
						</tr>
						<tr>
							<th>氏名</th>
								<td class="name">
									<ul>
										<li><input type="text" placeholder="カナ" v-model="inputForm.ryak" v-on:change="changeRyak"></li>
										<li><input type="text" placeholder="漢字" v-model="inputForm.name" v-on:change="changeName"></li>
									</ul>
								</td>
							<th>受診時間</th>
								<td>
									<select v-model="inputForm.tmzn">
										<option value="">選択</option>
										<option v-for="item in inputForm.tmznList" v-bind:value="item.tmzn" v-bind:key="item.tmzn" v-on:change="changeTmzn">
											{{item.znnm}}
										</option>
									</select>
								</td>
						</tr>
					</tbody>
				</table>
				<div class="csvPtSelect">
					<div>
						<!-- 出力パターン -->
						<select v-model="inputForm.ptcd">
							<option value="">未選択</option>
							<option v-for="item in inputForm.csvPtList" v-bind:value="item.ptcd" v-bind:key="item.ptcd">
								{{item.ptnm}}
							</option>
						</select>
						<p v-on:click="onMoveCsvPatternList">CSV出力項目の確認・変更</p>
					</div>
					<button class="confBtn" v-on:click="onConfirmCsvDownloadModalOpen">CSV出力</button>
				</div>
			</section>
			<!-- ▽ 検索結果 -->
			<section class="outputArea">
				<!-- 月毎予約状況 START -->
				<table class="listTbl">
					<caption class="listUp"><b>受診者一覧</b></caption>
					<thead>
						<tr>
							<th>No.</th>
							<td>予約番号</td><td>受診日</td><td>時間</td><td>氏名</td><td>カナ名</td><td>クライアント</td><td>コース</td><td>オプション</td><td>登録日</td><td>更新日</td><td>予約ステータス</td><td>ダウンロード状況</td><td></td>
						</tr>
					</thead>
						<tr v-for="(item,index) in filteredSearchList" v-bind:key="item.ukno">
							<th>{{index + 1}}</th>       <!-- No. -->
							<td>{{item.ukno}}</td>       <!-- 予約番号 -->
							<td>{{item.ykdy}}</td>       <!-- 受診日 -->
							<td>{{item.znnm}}</td>       <!-- 時間 -->
							<td>{{item.name}}</td>       <!-- 氏名 -->
							<td>{{item.ryak}}</td>       <!-- カナ名 -->
							<td>{{item.jgnm}}</td>       <!-- 健保組合 -->
							<td>{{item.ksNbnm}}</td>     <!-- コース -->
							<td>{{item.opkmNbnms}}</td>  <!-- オプション -->
							<td>{{item.crdt}}</td>       <!-- 登録日 -->
							<td>{{item.updt}}</td>       <!-- 更新日 -->
							<td>{{item.strYkst}}</td>    <!-- 予約ステータス -->
							<td>{{item.strCsst}}</td>    <!-- ダウンロード状況 -->
							<td class="btnLst"><button class="detailBtn" v-on:click="onDetail(item.ukno)">詳細</button></td>
						</tr>
				</table>
			</section>
		</section>
		<!-- △ mainContents END -->
		<!-- モーダルWindow S -->
		<modalWindow v-show="modal.validationError.isShow" v-on:close="onValidationErrorModalClose">
			<dt slot="modal-header">入力エラー</dt>
			<dd slot="modal-body">
				<errorMessageBox :errorMessages="modal.validationError.messages"></errorMessageBox>
			</dd>
			<dd slot="modal-footer"><a href="javascript:void(0)" v-on:click="onValidationErrorModalClose">閉じる</a></dd>
		</modalWindow>
		<!-- モーダルWindow E -->
		<!-- モーダルWindow S -->
		<modalWindow v-show="modal.confirmCsvDownload.isShow" v-on:close="onConfirmCsvDownloadModalClose">
			<dt slot="modal-header">CSV出力</dt>
			<dd slot="modal-body">
				<!-- modeによってモーダルに表示するメッセージ変更 -->
				<errorMessageBox :errorMessages="getCSVDownLoadMessages"></errorMessageBox>
			</dd>
			<dd slot="modal-footer">
				<!-- '0': ダウンロード確認の時に表示する -->
				<button v-show="modal.confirmCsvDownload.mode == '0'" v-on:click="csvDownLoad">OK</button>
				<!-- '0': ダウンロード確認及び'2': ダウンロード完了の時に表示する -->
				<a href="javascript:void(0)" v-show="modal.confirmCsvDownload.mode == '0' || modal.confirmCsvDownload.mode == '2'" v-on:click="onConfirmCsvDownloadModalClose">閉じる</a>
			</dd>
		</modalWindow>
		<!-- モーダルWindow E -->
		<!-- モーダルWindow S -->
		<modalWindow v-show="modal.systemError.isShow" v-on:close="onSystemErrorModalClose">
			<dt slot="modal-header">システムエラー</dt>
			<dd slot="modal-body">
				<errorMessageBox :errorMessages="modal.systemError.messages"></errorMessageBox>
			</dd>
			<dd slot="modal-footer"><a href="javascript:void(0)" v-on:click="onSystemErrorModalClose">閉じる</a></dd>
		</modalWindow>
		<!-- モーダルWindow E -->
	</div>
</template>
<script>
	var encoding = require("encoding");
	import { WIGA1Api } from '@/api'
	import * as types from '@/store/mutation-types'
	import * as ErrorCodes from '@/components/Utility/error-codes'
	import ErrorMessageBox from '@/components/Utility/ErrorMessageBox'
	import ModalWindow from '@/components/Utility/ModalWindow'
  import * as UtilityConsoleLog from '@/components/Utility/UtilityConsoleLog'

	export default {
		// モジュール名
		name: 'WIGA1',
		// 使用コンポーネント
		components: {
			// エラーメッセージ
			errorMessageBox: ErrorMessageBox,
			// モーダルウィンドウ
			modalWindow: ModalWindow
		},
		// データ
		data() {
			return {
				// 検索条件入力フォーム
				inputForm: {

					// クライアントリスト
					// jgcd: クライアントコード
					// jgnm: クライアント名
					jgyoList: [],
					
					// 年
					yearList: [],
					
					// 月
					monthList: [1,2,3,4,5,6,7,8,9,10,11,12],
					
					// 時間帯リスト
					// tmzn: 時間帯コード
					// znnm: 時間帯名称
					tmznList: [],

					// オプション分類リスト
					// opbr: オプション分類コード
					// nbnm: 内部名称
					opbrList: [],

					// オプション項目リスト
					// opbr: オプション分類コード
					// opcd: オプション項目コード
					// nbnm: 内部名称
					opkmList: [],

					// 枠リスト
					// waku: 枠
					// wknm: 枠名
					wakuList: [],
					
					// クライアントコード
					jgcd: '',

					// 健康保険組合名
					jgnm: '',

					// 企業名
					cmnm: '',

					// 保険証記号
					hkkg: '',

					// 患者番号
					trno: '',

					// 予約枠
					waku: '',

					// 予約番号
					ukno: '',

					// 予約年度
					nend: '',

					// オプション分類コード
					opbr: '',

					// オプション項目コード
					opcd: '',

					// 受診日
					ykdyStartYear: 0,
					ykdyStartMonth: 0,
					ykdyStartDate: 0,
					ykdyEndYear: 0,
					ykdyEndMonth: 0,
					ykdyEndDate: 0,

					// 予約登録日
					crdtStartYear: 0,
					crdtStartMonth: 0,
					crdtStartDate: 0,
					crdtEndYear: 0,
					crdtEndMonth: 0,
					crdtEndDate: 0,

					// 予約更新日
					updtStartYear: 0,
					updtStartMonth: 0,
					updtStartDate: 0,
					updtEndYear: 0,
					updtEndMonth: 0,
					updtEndDate: 0,

					// ステータス（ステータスコード）
					// 21: 予約済（確定式 新規確認未）
					// 22: 予約済（確定式 変更確認未）
					// 23: 予約済（確定式 確認済）
					// 91: キャンセル済（確認未）
					// 92: キャンセル済（確認済）
					// 99: キャンセル済（削除済）
					ykst: [],

					// カナ氏名
					ryak: '',

					// 漢字氏名
					name: '',

					// ダウンロード状況
					// 01: 未（新規）
					// 02: 未（変更・キャンセル）
					// 03: 済
					csst: [],

					// 受診時間（時間帯コード）
					tmzn: '',

					// 現在は使用していない（関連メソッドも残している、ストア保存関連は実装していない）
					sort: {
						key: '',
						isAsc: true
					},

					// 更新状況（DB検索必須項目）
					changeRequire: {

						// クライアントコード
						jgcdFlag: false,

						// 健康保険組合名
						jgnmFlag: false,

						// 企業名
						cmnmFlag: false,

						// 予約番号
						uknoFlag: false,

						// 予約年度
						nendFlag: false,

						// 受診日
						ykdyFlag: false,

						// 予約登録日
						crdtFlag: false,

						// 予約更新日
						updtFlag: false,

						// 保険証記号
						hkkgFlag: false,

						// 患者番号
						trnoFlag: false,

						// 予約枠
						wakuFlag: false,

						// オプション分類コード
						opbrFlag: false,

						// オプション項目コード
						opcdFlag: false,
					},

					// 更新状況（DB検索もしくはフィルタリング項目）
					changeNotRequire: {

						// ステータス
						ykstFlag: false,
						
						// カナ氏名
						ryakFlag: false,
						
						// 漢字氏名
						nameFlag: false,
						
						// ダウンロード状況
						csstFlag: false,
						
						// 受診時間
						tmznFlag: false,
					},

					// CSVパターンリスト
					// ptcd: パターンコード
					// ptnm: パターン名
					csvPtList: [],

					// CSVパターンコード
					ptcd: ''
				},

				// 予約情報検索結果
				// ukno: 予約受付番号
				// ykdy: 受診日（予約確定日）
				// znnm: 時間（時間帯名称）
				// name: 氏名（姓＋半角スペース＋名）
				// ryak: カナ名（姓＋半角スペース＋名）
				// jgnm: 健保機関名（クライアント名称）
				// ksNbnm: コース（コース内部名称）
				// opkmNbnms: オプション（オプション項目内部名称）
				// crdt: 登録日（予約作成日）
				// updt: 更新日
				// strYkst: 予約ステータス
				// strCsst: ダウンロード状況
				// yktm: 時間帯コード
				// ykst: ステータス
				// csst: ダウンロード状況
				searchList:[],

				// CSV各種情報
				csvInfo: {
					// ファイル名
					fileName: '',
					// ヘッダー部
					header: '',
					// ボディ部
					bodyList: []
				},

				watchflag: false,

				// モーダルウィンドウ
				modal: {
					validationError: {
						messages: [],
						isShow: false
					},
					confirmCsvDownload: {
						// ダウンロード中かどうか
						// '0': ダウンロード確認
						// '1': ダウンロード中
						// '2': ダウンロード完了
						mode: '0',
						isShow: false
					},
					systemError: {
						messages: [
							'システムエラーです。',
							'内容をもう一度ご確認ください。'
						],
						isShow: false
					},
				},
			}
		},
		// 監視プロパティ
		watch: {
			
			// 受診日　開始　年を監視
			'inputForm.ykdyStartYear': function (newYear, oldYear) {

				if(!this.watchflag) {
					return
				}

				// 受診日　開始　年の選択値に変更があれば
				// 初期値に戻す
				this.inputForm.ykdyStartDate = 0
			},
			// 受診日　開始　月を監視
			'inputForm.ykdyStartMonth': function (newYear, oldYear) {

				if(!this.watchflag) {
					return
				}

				// 受診日　開始　月の選択値に変更があれば
				// 初期値に戻す
				this.inputForm.ykdyStartDate = 0
			},
			// 受診日　終了　年を監視
			'inputForm.ykdyEndYear': function (newYear, oldYear) {

				if(!this.watchflag) {
					return
				}

				// 受診日　終了　年の選択値に変更があれば
				// 初期値に戻す
				this.inputForm.ykdyEndDate = 0
			},
			// 受診日　終了　月を監視
			'inputForm.ykdyEndMonth': function (newYear, oldYear) {

				if(!this.watchflag) {
					return
				}

				// 受診日　終了　月の選択値に変更があれば
				// 初期値に戻す
				this.inputForm.ykdyEndDate = 0
			},
			// 予約登録日　開始　年を監視
			'inputForm.crdtStartYear': function (newYear, oldYear) {

				if(!this.watchflag) {
					return
				}

				// 予約登録日　開始　年の選択値に変更があれば
				// 初期値に戻す
				this.inputForm.crdtStartDate = 0
			},
			// 予約登録日　開始　月を監視
			'inputForm.crdtStartMonth': function (newYear, oldYear) {

				if(!this.watchflag) {
					return
				}

				// 予約登録日　開始　月の選択値に変更があれば
				// 初期値に戻す
				this.inputForm.crdtStartDate = 0
			},
			// 予約登録日　終了　年を監視
			'inputForm.crdtEndYear': function (newYear, oldYear) {

        if(!this.watchflag) {
					return
				}

				// 予約登録日　終了　年の選択値に変更があれば
				// 初期値に戻す
				this.inputForm.crdtEndDate = 0
			},
			// 予約登録日　終了　月を監視
			'inputForm.crdtEndMonth': function (newYear, oldYear) {

				if(!this.watchflag) {
					return
				}

				// 予約登録日　終了　月の選択値に変更があれば
				// 初期値に戻す
				this.inputForm.crdtEndDate = 0
			},
			// 予約更新日　開始　年を監視
			'inputForm.updtStartYear': function (newYear, oldYear) {

				if(!this.watchflag) {
					return
				}

				// 予約更新日　開始　年の選択値に変更があれば
				// 初期値に戻す
				this.inputForm.updtStartDate = 0
			},
			// 予約更新日　開始　月を監視
			'inputForm.updtStartMonth': function (newYear, oldYear) {

				if(!this.watchflag) {
					return
				}

				// 予約更新日　開始　月の選択値に変更があれば
				// 初期値に戻す
				this.inputForm.updtStartDate = 0
			},
			// 予約更新日　終了　年を監視
			'inputForm.updtEndYear': function (newYear, oldYear) {

				if(!this.watchflag) {
					return
				}

				// 予約更新日　終了　年の選択値に変更があれば
				// 初期値に戻す
				this.inputForm.updtEndDate = 0
			},
			// 予約更新日　終了　月を監視
			'inputForm.updtEndMonth': function (newYear, oldYear) {

				if(!this.watchflag) {
					return
				}

				// 予約更新日　終了　月の選択値に変更があれば
				// 初期値に戻す
				this.inputForm.updtEndDate = 0
			},
			// オプション分類の選択値（オプション分類コード）を監視
			'inputForm.opbr':function (newOpbr, oldOpbr) {

				if(!this.watchflag) {
					return
				}

				  // オプション分類の選択値に変更があれば
				  // 初期値に戻す
				  this.inputForm.opcd = ''
			},
		},
		computed: {
			// 受診日　開始日　日付のプルダウン内容を生成
			computedListYkdyStartDate: function () {

				var tempListDate = []

				// 当月の最終日の求め方
				// 本来8月なら第二引数（月）は7を与えるべきだが
				// 本来8月なら第三引数（日）に0を与えて
				// 次月の最初の日（1日）より一日前（0日）で
				// 当月の最終日を求める
				var lastDate = new Date(
					this.inputForm.ykdyStartYear,
					this.inputForm.ykdyStartMonth, 0).getDate()

				for (var i = 1; i <= lastDate; i++) {
					tempListDate.push(i)
				}

				return tempListDate
			},
			// 受診日　終了日　日付のプルダウン内容を生成
			computedListYkdyEndDate: function () {

				var tempListDate = []

				// 当月の最終日の求め方
				// 本来8月なら第二引数（月）は7を与えるべきだが
				// 本来8月なら第三引数（日）に0を与えて
				// 次月の最初の日（1日）より一日前（0日）で
				// 当月の最終日を求める
				var lastDate = new Date(
					this.inputForm.ykdyEndYear,
					this.inputForm.ykdyEndMonth, 0).getDate()

				for (var i = 1; i <= lastDate; i++) {
					tempListDate.push(i)
				}

				return tempListDate
			},
			// 予約登録日　開始日　日付のプルダウン内容を生成
			computedListCrdtStartDate: function () {

				var tempListDate = []

				// 当月の最終日の求め方
				// 本来8月なら第二引数（月）は7を与えるべきだが
				// 本来8月なら第三引数（日）に0を与えて
				// 次月の最初の日（1日）より一日前（0日）で
				// 当月の最終日を求める
				var lastDate = new Date(
					this.inputForm.crdtStartYear,
					this.inputForm.crdtStartMonth, 0).getDate()

				for (var i = 1; i <= lastDate; i++) {
					tempListDate.push(i)
				}

				return tempListDate
			},
			// 予約登録日　終了日　日付のプルダウン内容を生成
			computedListCrdtEndDate: function () {

				var tempListDate = []

				// 当月の最終日の求め方
				// 本来8月なら第二引数（月）は7を与えるべきだが
				// 本来8月なら第三引数（日）に0を与えて
				// 次月の最初の日（1日）より一日前（0日）で
				// 当月の最終日を求める
				var lastDate = new Date(
					this.inputForm.crdtEndYear,
					this.inputForm.crdtEndMonth, 0).getDate()

				for (var i = 1; i <= lastDate; i++) {
					tempListDate.push(i)
				}

				return tempListDate
			},
			// 予約更新日　開始日　日付のプルダウン内容を生成
			computedListUpdtStartDate: function () {

				var tempListDate = []

				// 当月の最終日の求め方
				// 本来8月なら第二引数（月）は7を与えるべきだが
				// 本来8月なら第三引数（日）に0を与えて
				// 次月の最初の日（1日）より一日前（0日）で
				// 当月の最終日を求める
				var lastDate = new Date(
					this.inputForm.updtStartYear,
					this.inputForm.updtStartMonth, 0).getDate()

				for (var i = 1; i <= lastDate; i++) {
					tempListDate.push(i)
				}

				return tempListDate
			},
			// 予約更新日　終了日　日付のプルダウン内容を生成
			computedListUpdtEndDate: function () {

				var tempListDate = []

				// 当月の最終日の求め方
				// 本来8月なら第二引数（月）は7を与えるべきだが
				// 本来8月なら第三引数（日）に0を与えて
				// 次月の最初の日（1日）より一日前（0日）で
				// 当月の最終日を求める
				var lastDate = new Date(
					this.inputForm.updtEndYear,
					this.inputForm.updtEndMonth, 0).getDate()

				for (var i = 1; i <= lastDate; i++) {
					tempListDate.push(i)
				}

				return tempListDate
			},
			filteredOpbrList: function() {

				var tempFilteredList = []

				tempFilteredList = this.inputForm.opkmList.filter(
					item => this.inputForm.opbr == item.opbr
				)

				return tempFilteredList
			},
			// フィルタ済み予約情報検索結果
			// ukno: 予約受付番号
			// ykdy: 受診日（予約確定日）
			// znnm: 時間（時間帯名称）
			// ryak: カナ名（姓＋半角スペース＋名）
			// name: 氏名（姓＋半角スペース＋名）
			// jgnm: 健保機関名（クライアント名称）
			// ksNbnm: コース（コース内部名称）
			// opkmNbnms: オプション（オプション項目内部名称）
			// crdt: 登録日（予約作成日）
			// updt: 更新日
			// strYkst: 予約ステータス
			// strCsst: ダウンロード状況
			// tmzn: 時間帯コード
			// ykst: ステータス
			// csst: ダウンロード状況
			filteredSearchList: function() {

				// sort()は元の配列もソートしてしまうので、slice()で配列をコピーする
				var tempFilteredList = []
				tempFilteredList = this.getFilteredSearchList()

				return tempFilteredList
			},
			// 並び順（昇順降順）ボタン
			computedSortButtonName: function() {
				
				var result = this.inputForm.sort.isAsc ? '▲昇順' : '▼降順' 

				return result
			},
			// CSVダウンロードモーダルウィンドウ
			getCSVDownLoadMessages: function() {

				var tempMessages = []

				if('0' == this.modal.confirmCsvDownload.mode){
					tempMessages = ['ダウンロードしてもよろしいでしょうか。']
				} else if('1' == this.modal.confirmCsvDownload.mode) {
					tempMessages = [
						'ダウンロード中です。しばらくお待ちください。',
						'ダウンロードには数分かかることがございます。'
					]
				} else if('2' == this.modal.confirmCsvDownload.mode) {
					tempMessages = ['ダウンロード完了しました。']
				} 

				return tempMessages
			}
		},
		created: function(){

			UtilityConsoleLog.consoleLog('WIGA1::mounted Start')

			this.firstDisplay()

			UtilityConsoleLog.consoleLog('WIGA1::mounted End')

		},
		methods: {
			// 初期表示
			firstDisplay: function() {
				UtilityConsoleLog.consoleLog('WIGA1::firstDisplay Start')

				this.inputForm.sort.key = 'ukno'

				this.watchflag = false
				// ストアから前回検索時の値を取得
				this.inputForm.jgcd = this.$store.state.adminWiga11Search.jgcd
				this.inputForm.jgnm = this.$store.state.adminWiga11Search.jgnm
				this.inputForm.cmnm = this.$store.state.adminWiga11Search.cmnm
				this.inputForm.hkkg = this.$store.state.adminWiga11Search.hkkg
        this.inputForm.trno = this.$store.state.adminWiga11Search.trno
				this.inputForm.waku = this.$store.state.adminWiga11Search.waku
				this.inputForm.ukno = this.$store.state.adminWiga11Search.ukno
				this.inputForm.nend = this.$store.state.adminWiga11Search.nend

				if(0 == this.$store.state.adminWiga11Search.nend
				   || '' == this.$store.state.adminWiga11Search.nend) {
					this.inputForm.nend = ''
				}

				this.inputForm.opbr = this.$store.state.adminWiga11Search.opbr
				this.inputForm.opcd = this.$store.state.adminWiga11Search.opcd
				this.inputForm.ykdyStartYear = this.$store.state.adminWiga11Search.ykdyStartYear
				this.inputForm.ykdyStartMonth = this.$store.state.adminWiga11Search.ykdyStartMonth
				this.inputForm.ykdyStartDate = this.$store.state.adminWiga11Search.ykdyStartDate
				this.inputForm.ykdyEndYear = this.$store.state.adminWiga11Search.ykdyEndYear
				this.inputForm.ykdyEndMonth = this.$store.state.adminWiga11Search.ykdyEndMonth
				this.inputForm.ykdyEndDate = this.$store.state.adminWiga11Search.ykdyEndDate
				this.inputForm.crdtStartYear = this.$store.state.adminWiga11Search.crdtStartYear
				this.inputForm.crdtStartMonth = this.$store.state.adminWiga11Search.crdtStartMonth
				this.inputForm.crdtStartDate = this.$store.state.adminWiga11Search.crdtStartDate
				this.inputForm.crdtEndYear = this.$store.state.adminWiga11Search.crdtEndYear
				this.inputForm.crdtEndMonth = this.$store.state.adminWiga11Search.crdtEndMonth
				this.inputForm.crdtEndDate = this.$store.state.adminWiga11Search.crdtEndDate
				this.inputForm.updtStartYear = this.$store.state.adminWiga11Search.updtStartYear
				this.inputForm.updtStartMonth = this.$store.state.adminWiga11Search.updtStartMonth
				this.inputForm.updtStartDate = this.$store.state.adminWiga11Search.updtStartDate
				this.inputForm.updtEndYear = this.$store.state.adminWiga11Search.updtEndYear
				this.inputForm.updtEndMonth = this.$store.state.adminWiga11Search.updtEndMonth
				this.inputForm.updtEndDate = this.$store.state.adminWiga11Search.updtEndDate
				this.inputForm.ykst = this.$store.state.adminWiga11Search.ykst
				this.inputForm.ryak = this.$store.state.adminWiga11Search.ryak
				this.inputForm.name = this.$store.state.adminWiga11Search.name
				this.inputForm.csst = this.$store.state.adminWiga11Search.csst
				this.inputForm.tmzn = this.$store.state.adminWiga11Search.tmzn

				// 整数型の型を確認する
				var tempNend = 0
				if ('' != this.inputForm.nend) {
				tempNend = this.checkNumber(this.inputForm.nend)
					if(tempNend == -1) {
						this.onValidationErrorModalOpen(
							['年度は整数で入力してください。'])
						return
					}
				}

				// 非同期通信
				WIGA1Api.FirstDisplay({
					token: this.$store.state.auth.token,
					ircd: this.$store.state.auth.ircd,
					jgcd: this.inputForm.jgcd,
					jgnm: this.inputForm.jgnm,
					cmnm: this.inputForm.cmnm,
					ukno: this.inputForm.ukno,
					nend: tempNend,
					ykdyStartYear: this.inputForm.ykdyStartYear,
					ykdyStartMonth: this.inputForm.ykdyStartMonth,
					ykdyStartDate: this.inputForm.ykdyStartDate,
					ykdyEndYear: this.inputForm.ykdyEndYear,
					ykdyEndMonth: this.inputForm.ykdyEndMonth,
					ykdyEndDate: this.inputForm.ykdyEndDate,
					crdtStartYear: this.inputForm.crdtStartYear,
					crdtStartMonth: this.inputForm.crdtStartMonth,
					crdtStartDate: this.inputForm.crdtStartDate,
					crdtEndYear: this.inputForm.crdtEndYear,
					crdtEndMonth: this.inputForm.crdtEndMonth,
					crdtEndDate: this.inputForm.crdtEndDate,
					updtStartYear: this.inputForm.updtStartYear,
					updtStartMonth: this.inputForm.updtStartMonth,
					updtStartDate: this.inputForm.updtStartDate,
					updtEndYear: this.inputForm.updtEndYear,
					updtEndMonth: this.inputForm.updtEndMonth,
					updtEndDate: this.inputForm.updtEndDate,
					hkkg: this.inputForm.hkkg,
					trno: this.inputForm.trno,
					waku: this.inputForm.waku,
					opbr: this.inputForm.opbr,
					opcd: this.inputForm.opcd,
					ykst: this.inputForm.ykst,
					ryak: this.inputForm.ryak,
					name: this.inputForm.name,
					csst: this.inputForm.csst,
					tmzn: this.inputForm.tmzn
				}).then(({ responce }) => {

					if (responce.data.errorCode == ErrorCodes.ERRORCODE_DEFAULT) {

						// クライアントリスト
						this.inputForm.jgyoList = responce.data.jgyoList
						// 年プルダウン用
						this.inputForm.yearList = responce.data.yearList
						// 時間帯リスト
						this.inputForm.tmznList = responce.data.tmznList
						// オプション分類リスト
						this.inputForm.opbrList = responce.data.opbrList
						// オプション項目リスト
						this.inputForm.opkmList = responce.data.opkmList
						// 枠リスト
						this.inputForm.wakuList = responce.data.wakuList

						// CSVパターンリストプルダウンに初期値設定
						this.inputForm.ptcd = responce.data.firstChoicePtcd

						// CSVパターンリスト
						this.inputForm.csvPtList = responce.data.csvPtList

						// 検索結果
						this.searchList = responce.data.searchList

						// 年度
						if(this.searchList.length == 0) {
              this.inputForm.nend = responce.data.nend
						}

						this.watchflag = true

					} else if (responce.data.errorCode == ErrorCodes.ERRORCODE_SIMPLEITEM
							|| responce.data.errorCode == ErrorCodes.ERRORCODE_SYSTEM
							|| responce.data.errorCode == ErrorCodes.ERRORCODE_DB) {
						// システム、DBエラー時
						this.onSystemErrorModalOpen()
					}
				}).catch(() => {
					this.onSystemErrorModalOpen()
				}).finally(() => {
					UtilityConsoleLog.consoleLog('MasterWIGA1::firstDisplay End')
				})
			},
			// 検索
			onSearch: function() {
				UtilityConsoleLog.consoleLog('MasterWIGA1::onSearch Start')

				// 整数型の型を確認する
				var tempNend = 0
				if ('' != this.inputForm.nend) {
				tempNend = this.checkNumber(this.inputForm.nend)
					if(tempNend == -1) {
						this.onValidationErrorModalOpen(
							['年度は整数で入力してください。'])
						return
					}
				}

				// 非同期通信
				WIGA1Api.Search({
					token: this.$store.state.auth.token,
					ircd: this.$store.state.auth.ircd,
					jgcd: this.inputForm.jgcd,
					jgnm: this.inputForm.jgnm,
					cmnm: this.inputForm.cmnm,
					ukno: this.inputForm.ukno,
					nend: tempNend,
					ykdyStartYear: this.inputForm.ykdyStartYear,
					ykdyStartMonth: this.inputForm.ykdyStartMonth,
					ykdyStartDate: this.inputForm.ykdyStartDate,
					ykdyEndYear: this.inputForm.ykdyEndYear,
					ykdyEndMonth: this.inputForm.ykdyEndMonth,
					ykdyEndDate: this.inputForm.ykdyEndDate,
					crdtStartYear: this.inputForm.crdtStartYear,
					crdtStartMonth: this.inputForm.crdtStartMonth,
					crdtStartDate: this.inputForm.crdtStartDate,
					crdtEndYear: this.inputForm.crdtEndYear,
					crdtEndMonth: this.inputForm.crdtEndMonth,
					crdtEndDate: this.inputForm.crdtEndDate,
					updtStartYear: this.inputForm.updtStartYear,
					updtStartMonth: this.inputForm.updtStartMonth,
					updtStartDate: this.inputForm.updtStartDate,
					updtEndYear: this.inputForm.updtEndYear,
					updtEndMonth: this.inputForm.updtEndMonth,
					updtEndDate: this.inputForm.updtEndDate,
					hkkg: this.inputForm.hkkg,
					trno: this.inputForm.trno,
					waku: this.inputForm.waku,
					opbr: this.inputForm.opbr,
					opcd: this.inputForm.opcd,
					ykst: this.inputForm.ykst,
					ryak: this.inputForm.ryak,
					name: this.inputForm.name,
					csst: this.inputForm.csst,
					tmzn: this.inputForm.tmzn
				}).then(({ responce }) => {

					if (responce.data.errorCode == ErrorCodes.ERRORCODE_DEFAULT) {
						this.searchList = responce.data.searchList

            this.$store.commit(
							types.ADMIN_WIGA1_SEARCH,
							{
								jgcd: this.inputForm.jgcd,
								jgnm: this.inputForm.jgnm,
								cmnm: this.inputForm.cmnm,
								hkkg: this.inputForm.hkkg,
								trno: this.inputForm.trno,
								waku: this.inputForm.waku,
								ukno: this.inputForm.ukno,
								nend: this.inputForm.nend,
								opbr: this.inputForm.opbr,
								opcd: this.inputForm.opcd,
								ykdyStartYear: this.inputForm.ykdyStartYear,
								ykdyStartMonth: this.inputForm.ykdyStartMonth,
								ykdyStartDate: this.inputForm.ykdyStartDate,
								ykdyEndYear: this.inputForm.ykdyEndYear,
								ykdyEndMonth: this.inputForm.ykdyEndMonth,
								ykdyEndDate: this.inputForm.ykdyEndDate,
								crdtStartYear: this.inputForm.crdtStartYear,
								crdtStartMonth: this.inputForm.crdtStartMonth,
								crdtStartDate: this.inputForm.crdtStartDate,
								crdtEndYear: this.inputForm.crdtEndYear,
								crdtEndMonth: this.inputForm.crdtEndMonth,
								crdtEndDate: this.inputForm.crdtEndDate,
								updtStartYear: this.inputForm.updtStartYear,
								updtStartMonth: this.inputForm.updtStartMonth,
								updtStartDate: this.inputForm.updtStartDate,
								updtEndYear: this.inputForm.updtEndYear,
								updtEndMonth: this.inputForm.updtEndMonth,
								updtEndDate: this.inputForm.updtEndDate,
								ykst: this.inputForm.ykst,
								ryak: this.inputForm.ryak,
								name: this.inputForm.name,
								csst: this.inputForm.csst,
								tmzn: this.inputForm.tmzn
							}
						)

					} else if (responce.data.errorCode == ErrorCodes.ERRORCODE_INPUTSIMPLEITEM
						|| responce.data.errorCode == ErrorCodes.ERRORCODE_INPUTCORRECTION) {
						// 入力エラーダイアログを流用する
						this.onValidationErrorModalOpen(responce.data.errorMessagesList)
					} else if (responce.data.errorCode == ErrorCodes.ERRORCODE_SIMPLEITEM
							|| responce.data.errorCode == ErrorCodes.ERRORCODE_SYSTEM
							|| responce.data.errorCode == ErrorCodes.ERRORCODE_DB) {
						// システム、DBエラー時
						this.onSystemErrorModalOpen()
					}
				}).catch(() => {
					this.onSystemErrorModalOpen()
				}).finally(() => {
					UtilityConsoleLog.consoleLog('WIGA1::onSearch End')
				})

			},
			// CSV出力
			csvDownLoad: function() {
				UtilityConsoleLog.consoleLog('WIGA1::csvDownLoad Start')

				// '1': ダウンロード中に設定する
				this.modal.confirmCsvDownload.mode = '1'

				var tempUknos = []
				tempUknos = this.getUknos()

				// 非同期通信
				WIGA1Api.CsvDownload({
					token: this.$store.state.auth.token,
					ircd: this.$store.state.auth.ircd,
					ptcd: this.inputForm.ptcd,
					uknos: tempUknos
				}).then(({responce}) => {
					if (responce.data.errorCode == ErrorCodes.ERRORCODE_DEFAULT) {

						this.csvInfo.fileName = responce.data.fileName
						this.csvInfo.header = responce.data.header
						this.csvInfo.bodyList = responce.data.bodyList

						this.downloadCsv()

						// '2': ダウンロード完了に設定する
						this.modal.confirmCsvDownload.mode = '2'

					} else if(responce.data.errorCode == ErrorCodes.ERRORCODE_CORRECTION) {
						this.onValidationErrorModalOpen(responce.data.errorMessagesList)
					} else if(responce.data.errorCode == ErrorCodes.ERRORCODE_SIMPLEITEM
							|| responce.data.errorCode == ErrorCodes.ERRORCODE_SYSTEM
							|| responce.data.errorCode == ErrorCodes.ERRORCODE_DB) {
						// システム、DBエラー時
						this.onSystemErrorModalOpen()
					}
				}).catch(() => {
					this.onSystemErrorModalOpen()
				}).finally(() => {
					UtilityConsoleLog.consoleLog('WIGA1::csvDownLoad End')
				})
			},
			// CSVパターン一覧へボタン押下時
			onMoveCsvPatternList: function() {
				UtilityConsoleLog.consoleLog('WIGA1::onMoveCsvPatternList Start')

				// CSVパターン一覧へ遷移
				this.$router.push("/CSVPatternList")

				UtilityConsoleLog.consoleLog('WIGA1::onMoveCsvPatternList End')
			},
			// 検索結果リスト詳細ボタン押下時
			onDetail: function (in_ukno) {
				UtilityConsoleLog.consoleLog('WIGA1::onDetail Start')

        // ストア値の更新
        this.$store.commit(
        	types.ADMIN_USERCHOICE_WIGA1_DETAIL,
					{
						ukno: in_ukno
					})
				
				// 予約状況編集へ遷移
				this.$router.push("/WIGA1Detail")

				UtilityConsoleLog.consoleLog('WIGA1::onDetail End')
			},
			// ソート順の変更(未使用)
			sortBy: function(in_key) {
				// ソート順をセット 
				this.inputForm.sort.isAsc = this.inputForm.sort.key === in_key ? !this.inputForm.sort.isAsc : true
				// ソートキーをセット
				if(in_key) {
					this.inputForm.sort.key = in_key
				} else {
					this.inputForm.sort.key = 'ukno'
				}
			},
			// Number型がString型になっていた場合数値に直して返す
			checkNumber: function (value0) {

				UtilityConsoleLog.consoleLog('WIGA1::checkNumber Start')

				var tempType = typeof value0
				var tempValue = 0

				if (tempType == 'number') {
					tempValue = value0
				} else {

					var regexp = new RegExp(/^[0-9]+(\.[0-9]+)?$/)
					var flagNumber = regexp.test(value0)

					// 文字列型の数値ではないとき
					if (!flagNumber) {
						tempValue = -1
					} else {
						tempValue = Number(value0)
					}
				}

				UtilityConsoleLog.consoleLog('WIGA1::checkNumber End')

				return tempValue
			},
			// 予約情報検索結果を配列で取得
			getUknos: function() {

				var resultUknos = []

				// 現在の画面の入力値でフィルターをかける
				var tempFilteredList = []
				tempFilteredList = this.getFilteredSearchList()

				for(var i=0;i<tempFilteredList.length;i++) {
					resultUknos.push(tempFilteredList[i].ukno)
				}

				return resultUknos
			},
			// CSV出力ボタン押下時
			validationCsvDownload: function() {
				var resultMessageList = []

				if('' == this.inputForm.ptcd) {
					resultMessageList.push('CSVパターンが未選択です。')
				}

				if(this.searchList.length == 0) {
					resultMessageList.push('現在の検索条件で出力できるレコード数は0件です。')
				}

				return resultMessageList
			},
			// フィルタ済み予約情報検索結果を取得
			// ukno: 予約受付番号
			// ykdy: 受診日（予約確定日）
			// znnm: 時間（時間帯名称）
			// ryak: カナ名（姓＋半角スペース＋名）
			// name: 氏名（姓＋半角スペース＋名）
			// jgnm: 健保機関名（クライアント名称）
			// ksNbnm: コース（コース内部名称）
			// opkmNbnms: オプション（オプション項目内部名称）
			// crdt: 登録日（予約作成日）
			// updt: 更新日
			// strYkst: 予約ステータス
			// strCsst: ダウンロード状況
			// tmzn: 時間帯コード
			// ykst: ステータス
			// csst: ダウンロード状況
			getFilteredSearchList: function() {

				// sort()は元の配列もソートしてしまうので、slice()で配列をコピーする
				var tempFilteredList = []
				tempFilteredList = this.searchList.slice()

				// ソート実施
				if(this.inputForm.sort.key){
					tempFilteredList.sort((a,b) => {
					
						// デフォルトのキーは予約番号
						var tempKey = 'ukno'

						if(this.inputForm.sort.key){
						 tempKey = this.inputForm.sort.key
						}

						a = a[tempKey]
						b = b[tempKey]

						return (a === b ? 0 : a > b ? 1: -1) * (this.inputForm.sort.isAsc ? 1 : -1)
					})
				}

				// 時間帯によるフィルタ
				if(this.inputForm.tmzn) {
					tempFilteredList = tempFilteredList.filter(
						item => this.inputForm.tmzn.indexOf(item.yktm) > -1
					)
				}

				// ステータスによるフィルタ
				if(this.inputForm.ykst.length > 0) {
					tempFilteredList = tempFilteredList.filter(
						item => this.inputForm.ykst.indexOf(item.ykst) > -1
					)
				}

				// カナ氏名によるフィルタ
				if(this.inputForm.ryak) {
					var tempZenkakuRyak = ''
					tempZenkakuRyak = this.zenkana2Hankana(this.inputForm.ryak)
					tempFilteredList = tempFilteredList.filter(
						item => item.ryak.indexOf(tempZenkakuRyak) > -1
					)
				}

				// 漢字氏名によるフィルタ
				if(this.inputForm.name) {
					tempFilteredList = tempFilteredList.filter(
						item => item.name.indexOf(this.inputForm.name) > -1
					)  
				}

				// ダウンロード状況によるフィルタ
				if(this.inputForm.csst.length > 0) {
					tempFilteredList = tempFilteredList.filter(
						item => this.inputForm.csst.indexOf(item.csst) > -1
					)
				}

				return tempFilteredList
			},
			// CSV出力（ヘッダー部、ボディ部の作成）
			downloadCsv: function() {

				UtilityConsoleLog.consoleLog('WIGA1::downloadCsv Start')

				var csv = ""
				this.csvInfo.bodyList.forEach(function(it) {
					csv += it + "\n"
				}.bind(csv))

				csv = this.csvInfo.header + "\n" + csv
				csv = encoding.convert(csv, 'SJIS')
				csv = new Uint8Array(csv)
				this.downloadCsvBlob(csv,this.csvInfo.fileName)
				UtilityConsoleLog.consoleLog('WIGA1::downloadCsv End')
			},
			// CSVファイル作成
			downloadCsvBlob: function(in_blob,in_fileName) {
				UtilityConsoleLog.consoleLog('WIGA1::downloadCsvBlob Start')

				if (window.navigator.msSaveOrOpenBlob) {
					// for IE,Edge
					var blob = new Blob([in_blob], { "type": "text/csv" })
					window.navigator.msSaveOrOpenBlob(blob, in_fileName)
				} else {
					// for chrome, firefox
					const url = URL.createObjectURL(new Blob([in_blob], { type: 'text/csv' }))
					const linkEl = document.createElement('a')
					linkEl.href = url
					linkEl.setAttribute('download', in_fileName)
					document.body.appendChild(linkEl)
					linkEl.click()
					URL.revokeObjectURL(url)
					linkEl.parentNode.removeChild(linkEl)
				}

				UtilityConsoleLog.consoleLog('WIGA1::downloadCsvBlob End')
			},
			// 受診者抽出画面絞り込み項目欄 ステータス
			changeYkst: function () {
				this.$store.commit(
					types.ADMIN_WIGA1_SEARCH_YKST,
					{
						ykst: this.inputForm.ykst
					}
				)
			},
			// 受診者抽出画面絞り込み項目欄 ダウンロード状況
			changeCsst: function () {
				this.$store.commit(
					types.ADMIN_WIGA1_SEARCH_CSST,
					{
						csst: this.inputForm.csst
					}
				)
			},
			// 受診者抽出画面絞り込み項目欄 氏名（カナ）
			changeRyak: function () {
				this.$store.commit(
					types.ADMIN_WIGA1_SEARCH_RYAK,
					{
						ryak: this.inputForm.ryak
					}
				)
			},
			// 受診者抽出画面絞り込み項目欄 氏名（漢字）
			changeName: function () {
				this.$store.commit(
					types.ADMIN_WIGA1_SEARCH_NAME,
					{
						name: this.inputForm.name
					}
				)
			},
			// 受診者抽出画面絞り込み項目欄 受診時間
			changeTmzn: function () {
				this.$store.commit(
					types.ADMIN_WIGA1_SEARCH_TMZN,
					{
						tmzn: this.inputForm.tmzn
					}
				)
			},
			// バリデーションエラーモーダルとしてエラーモーダルを開く
			// errorMessagesは文字列配列であること
			// errorMessages = [
			//  'エラーメッセージ'
			// ]
			onValidationErrorModalOpen: function (errorMessages) {
				UtilityConsoleLog.consoleLog('WIGA1::onValidationErrorModalOpen Start')

				var tempMessages = [
					'入力エラーです。',
					'以下の内容をもう一度ご確認ください'
				]
				
				errorMessages.forEach((item)=>{
					tempMessages.push(item)
				})

				this.modal.validationError.messages = tempMessages
				this.modalOpen('validationError')

				UtilityConsoleLog.consoleLog('WIGA1::onValidationErrorModalOpen End')
			},
			// バリデーションエラーモーダルとしてエラーモーダルを閉じる
			onValidationErrorModalClose: function () {
				UtilityConsoleLog.consoleLog('WIGA1::onValidationErrorModalClose Start')

				this.modalClose('validationError')

				UtilityConsoleLog.consoleLog('WIGA1::onValidationErrorModalClose End')
			},
			// CSVダウンロード確認ーモーダルとしてモーダルを開く
			onConfirmCsvDownloadModalOpen: function () {
				UtilityConsoleLog.consoleLog('WIGA1::onConfirmCsvDownloadModalOpen Start')

				var errorMessageList = this.validationCsvDownload()
				if(errorMessageList.length > 0){
					this.onValidationErrorModalOpen(errorMessageList)
					UtilityConsoleLog.consoleLog('WIGA1::onConfirmCsvDownloadModalOpen End')
					return
				}

				// ダウンロード確認でモーダル表示
				this.modal.confirmCsvDownload.mode = '0'
				this.modalOpen('confirmCsvDownload')

				UtilityConsoleLog.consoleLog('WIGA1::onConfirmCsvDownloadModalOpen End')
			},
			// CSVダウンロード確認ーモーダルとしてモーダルを閉じる
			onConfirmCsvDownloadModalClose: function () {
				UtilityConsoleLog.consoleLog('WIGA1::onConfirmCsvDownloadModalClose Start')

				this.modalClose('confirmCsvDownload')

				UtilityConsoleLog.consoleLog('WIGA1::onConfirmCsvDownloadModalClose End')
			},
			// システムエラーモーダルとしてエラーモーダルを開く
			onSystemErrorModalOpen: function () {
				UtilityConsoleLog.consoleLog('WIGA1::onSystemErrorModalOpen Start')

				this.modalOpen('systemError')

				UtilityConsoleLog.consoleLog('WIGA1::onSystemErrorModalOpen End')
			},
			// システムエラーモーダルウィンドウの閉じるボタン
			onSystemErrorModalClose: function () {
				UtilityConsoleLog.consoleLog('WIGA1::onSystemErrorModalClose Start')

				this.modalClose('systemError')
				this.$router.push("/AdminLogin")

				UtilityConsoleLog.consoleLog('WIGA1::onSystemErrorModalClose End')
			},
			// モーダルウィンドウを開く
			modalOpen: function (modalName) {
				UtilityConsoleLog.consoleLog('WIGA1::modalOpen Start')

				// すべてのモーダルを閉じる
				this.allModalClose()

				this.modal[modalName].isShow = true

				UtilityConsoleLog.consoleLog('WIGA1::modalOpen End')
			},
			// モーダルウィンドウを閉じる
			modalClose: function (modalName) {
				UtilityConsoleLog.consoleLog('WIGA1::modalClose Start')

				this.modal[modalName].isShow = false

				UtilityConsoleLog.consoleLog('WIGA1::modalClose End')
			},
			// 全てのモーダルを閉じる
			allModalClose: function() {  
				for(var key in this.modal) {
					this.modal[key].isShow = false
				}
			},
			// クライアントコード変更時
			changeJgcdFlag: function() {
				this.jgcdFlag = true
			},
			// 健康保険組合名変更時
			changeJgnmFlag: function() {
				this.jgnmFlag = true
			},
			// 企業名変更時
			changeCmnmFlag: function() {
				this.cmnmFlag = true
			},
			// 予約番号変更時
			changeUknoFlag: function() {
				this.uknoFlag = true
			},
			// 予約年度変更時
			changeNendFlag: function() {
				this.nendFlag = true
			},
			// 受診日変更時
			changeYkdyFlag: function() {
				this.ykdyFlag = true
			},
			// 予約登録日変更時
			changeCrdtFlag: function() {
				this.crdtFlag = true
			},
			// 予約更新日変更時
			changeUpdtFlag: function() {
				this.updtFlag = true
			},
			// 保険証記号変更時
			changeHkkgFlag: function() {
				this.hkkgFlag = true
			},
			// 患者番号変更時
			changeTrnoFlag: function() {
				this.trnoFlag = true
			},
			// 予約枠変更時
			changeWakuFlag: function() {
				this.wakuFlag = true
			},
			// オプション分類コード、オプション項目コード変更時
			changeOpFlag: function() {
				this.opFlag = true
			},
		  // 全角カナを半角カナに変換する
			zenkana2Hankana: function (in_str) {
				var kanaMap = {
				     "ガ": "ｶﾞ", "ギ": "ｷﾞ", "グ": "ｸﾞ", "ゲ": "ｹﾞ", "ゴ": "ｺﾞ",
				     "ザ": "ｻﾞ", "ジ": "ｼﾞ", "ズ": "ｽﾞ", "ゼ": "ｾﾞ", "ゾ": "ｿﾞ",
				     "ダ": "ﾀﾞ", "ヂ": "ﾁﾞ", "ヅ": "ﾂﾞ", "デ": "ﾃﾞ", "ド": "ﾄﾞ",
				     "バ": "ﾊﾞ", "ビ": "ﾋﾞ", "ブ": "ﾌﾞ", "ベ": "ﾍﾞ", "ボ": "ﾎﾞ",
				     "パ": "ﾊﾟ", "ピ": "ﾋﾟ", "プ": "ﾌﾟ", "ペ": "ﾍﾟ", "ポ": "ﾎﾟ",
				     "ヴ": "ｳﾞ", "ヷ": "ﾜﾞ", "ヺ": "ｦﾞ",
				     "ア": "ｱ", "イ": "ｲ", "ウ": "ｳ", "エ": "ｴ", "オ": "ｵ",
				     "カ": "ｶ", "キ": "ｷ", "ク": "ｸ", "ケ": "ｹ", "コ": "ｺ",
				     "サ": "ｻ", "シ": "ｼ", "ス": "ｽ", "セ": "ｾ", "ソ": "ｿ",
				     "タ": "ﾀ", "チ": "ﾁ", "ツ": "ﾂ", "テ": "ﾃ", "ト": "ﾄ",
				     "ナ": "ﾅ", "ニ": "ﾆ", "ヌ": "ﾇ", "ネ": "ﾈ", "ノ": "ﾉ",
				     "ハ": "ﾊ", "ヒ": "ﾋ", "フ": "ﾌ", "ヘ": "ﾍ", "ホ": "ﾎ",
				     "マ": "ﾏ", "ミ": "ﾐ", "ム": "ﾑ", "メ": "ﾒ", "モ": "ﾓ",
				     "ヤ": "ﾔ", "ユ": "ﾕ", "ヨ": "ﾖ",
				     "ラ": "ﾗ", "リ": "ﾘ", "ル": "ﾙ", "レ": "ﾚ", "ロ": "ﾛ",
				     "ワ": "ﾜ", "ヲ": "ｦ", "ン": "ﾝ",
				     "ァ": "ｧ", "ィ": "ｨ", "ゥ": "ｩ", "ェ": "ｪ", "ォ": "ｫ",
				     "ッ": "ｯ", "ャ": "ｬ", "ュ": "ｭ", "ョ": "ｮ",
				     "。": "｡", "、": "､", "ー": "ｰ", "「": "｢", "」": "｣", "・": "･",
						 "　": " "
				}
				var reg = new RegExp('(' + Object.keys(kanaMap).join('|') + ')', 'g');
    			return in_str.replace(reg, function (match) {
                return kanaMap[match];
            }).replace(/゛/g, 'ﾞ').replace(/゜/g, 'ﾟ')
			}
		}
	}
</script>



// WEBPACK FOOTER //
// src/components/Admin/Master/WIGA1/WIGA1.vue